module.exports = __webpack_public_path__ + "9186599fc6cda6f9f31592321a51173d.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/videos/desktop_spot.mp4
// module id = 229
// module chunks = 0